/**
 * ISO 4217 currency catalog.
 *
 * Used by the receipt currency picker. Keep this list reasonably broad so
 * users can find their currency without needing to type the code, but not
 * exhaustive — the schema accepts ANY 3-letter ISO 4217 code, so if a
 * currency missing from this list ever shows up, the form's text input
 * lets the user enter it manually.
 *
 * Order: payout currencies first (employees in those payments will most
 * often have receipts in their own currency too), then a curated set of
 * common business-travel currencies sorted alphabetically.
 */
export const COMMON_CURRENCIES = [
    // Payout currencies
    { code: 'EUR', name: 'Euro' },
    { code: 'CHF', name: 'Swiss Franc' },
    { code: 'USD', name: 'US Dollar' },
    { code: 'GBP', name: 'British Pound' },
    { code: 'CLP', name: 'Chilean Peso' },
    { code: 'MXN', name: 'Mexican Peso' },
    { code: 'BRL', name: 'Brazilian Real' },
    // Other common business travel currencies
    { code: 'AUD', name: 'Australian Dollar' },
    { code: 'CAD', name: 'Canadian Dollar' },
    { code: 'CNY', name: 'Chinese Yuan' },
    { code: 'CZK', name: 'Czech Koruna' },
    { code: 'DKK', name: 'Danish Krone' },
    { code: 'HKD', name: 'Hong Kong Dollar' },
    { code: 'HUF', name: 'Hungarian Forint' },
    { code: 'INR', name: 'Indian Rupee' },
    { code: 'ILS', name: 'Israeli Shekel' },
    { code: 'JPY', name: 'Japanese Yen' },
    { code: 'KRW', name: 'Korean Won' },
    { code: 'NOK', name: 'Norwegian Krone' },
    { code: 'NZD', name: 'New Zealand Dollar' },
    { code: 'PLN', name: 'Polish Zloty' },
    { code: 'RON', name: 'Romanian Leu' },
    { code: 'SEK', name: 'Swedish Krona' },
    { code: 'SGD', name: 'Singapore Dollar' },
    { code: 'THB', name: 'Thai Baht' },
    { code: 'TRY', name: 'Turkish Lira' },
    { code: 'ZAR', name: 'South African Rand' },
];
const CODE_TO_NAME = COMMON_CURRENCIES.reduce((acc, c) => ({ ...acc, [c.code]: c.name }), {});
/** Return human-readable name for an ISO code, or the code itself if unknown. */
export function currencyName(code) {
    return CODE_TO_NAME[code.toUpperCase()] ?? code.toUpperCase();
}
//# sourceMappingURL=currencies.js.map